module.exports = __webpack_public_path__ + "static/media/Tech_titlePage.ec7d2822.png";